import { render } from "./RoadmapOverview.vue?vue&type=template&id=1cdd8240"
import script from "./RoadmapOverview.vue?vue&type=script&lang=js"
export * from "./RoadmapOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__